export const montarMensagemDeErro = (nomes) => {
    if (nomes.length === 1) {
        return `Não foi possível carregar o indicador ${nomes[0]}. Tente buscar novamente.`
    }

    const iniciais = nomes.slice(0, -1).join(', ')
    const ultimo = nomes[nomes.length - 1]

    return `Não foi possível carregar os indicadores ${iniciais} e ${ultimo}. Tente buscar novamente.`
}

// Junta as falhas que chegam quase juntas num aviso só, senão uma busca com o
// servidor fora empilharia um snackbar por indicador (maxSnack é 3).
export const criarAvisadorDeErro = (avisar, { agendar = setTimeout, cancelar = clearTimeout, atraso = 1500 } = {}) => {
    let nomes = new Set()
    let timer = null

    return (nome) => {
        nomes.add(nome)
        cancelar(timer)
        timer = agendar(() => {
            avisar(montarMensagemDeErro([...nomes]))
            nomes = new Set()
        }, atraso)
    }
}
